// format.ts — numbers and dates in the ACTIVE app locale, not the browser's.
//
// Before this, the dashboard called `toLocaleString()` / `toLocaleDateString(undefined, …)`
// with no locale, which follows the browser — correct while the preference is "system" and
// wrong the moment a user picks a language their browser is not set to. Routing every site
// through here also pins EN to 'en-US' (what `lib/usage.ts`'s formatCount already pinned), so
// formatted output is deterministic in tests instead of machine-dependent.
import type { Locale } from './index';

// Same decisions as `apps/web/app/lib/locale.ts`'s `INTL_LOCALE` (kept as a separate constant
// here per this file's own header comment — the dashboard's locale core doesn't share a
// runtime module with apps/web): `es` stays generic (no single Spanish-speaking country is
// "the" market), `pt` is pinned to `pt-BR` because Brazil is the target market.
const INTL_LOCALE: Record<Locale, string> = {
  en: 'en-US',
  vi: 'vi-VN',
  es: 'es',
  pt: 'pt-BR',
  fr: 'fr-FR',
  de: 'de-DE',
  ja: 'ja-JP',
  id: 'id-ID',
  zh: 'zh-CN',
};

export function formatNumber(n: number, locale: Locale): string {
  return n.toLocaleString(INTL_LOCALE[locale]);
}

export function formatDate(
  value: string | Date,
  locale: Locale,
  opts: Intl.DateTimeFormatOptions,
): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  return date.toLocaleDateString(INTL_LOCALE[locale], opts);
}

export function formatDateTime(
  value: string | Date,
  locale: Locale,
  opts?: Intl.DateTimeFormatOptions,
): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  return date.toLocaleString(INTL_LOCALE[locale], opts);
}
